export default __webpack_public_path__ + "img/2-365797f6.png";